module.exports = __webpack_public_path__ + "img/Innovation.f3f01cb7.png";